import { registerCopyEvent } from "../copyable";

registerCopyEvent("addressbook.address", "copyable_peer_id");
